// Generated by ReScript, PLEASE EDIT WITH CARE


let baseRoute = "/orders";

let createRoute = baseRoute + "/create";

function showRoute(id) {
  return baseRoute + "/" + id;
}

let orderSupplyRoute = "/ordersupplies";

export {
  baseRoute,
  createRoute,
  showRoute,
  orderSupplyRoute,
}
/* No side effect */
